module.exports = __webpack_public_path__ + "assets/img/marlin-lv.84626708.png";